









# import settings from '@/settings'

export default {
    name: 'pie_chart'

    props: {
        datas: {
            type: Array
            required: true
        }
        title: {
            type: String
        }
        detail: {
            type: String
        }
    }

    watch:
        datas: (value)->
            @pie_chart_options.series[0].data = value
            # console.log "WATCH PIE CHART ", value

    data: ()->
        self = @
        return {
            pie_chart_options: {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie'
                },
                title: false,
                tooltip: {
                    pointFormat: '<b>{point.percentage:.1f}% ({point.y})</b>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true
                    }
                },
                series: [
                    {
                        name: false,
                        colorByPoint: true,
                        data: [{'name':'aucune donnée', 'y':null}]
                    }
                ]
            }
        }

    beforeMount: ()->
        # console.log "PIE CHART", @datas
        @pie_chart_options.series[0].data = @datas
}
